module.exports = __webpack_public_path__ + "img/mmi-about-photo-06-mighty-minds-paulette.40907b79.png";